/** The Silia Learning screens a skeleton draws. */
export type LearningSkeletonKind = 'home' | 'stage' | 'news' | 'mcp';

/*
 * Local copies of the segments in ../../constants (a test keeps them in step): this file is in
 * the initial bundle and imports nothing of the feature.
 */
const SECTION = 'learning';
const NEWS = 'novedades';
const MCP = 'mcp';

/**
 * Anchored at both ends: a path that merely holds the word `learning`, or anything nested
 * under a stage, never matches. A stage id is one free segment, so RouteSkeleton runs this
 * before its substring tests (`/home`, `/metrics`, …). No lookbehind: Babel can't transpile
 * one and Safari < 16.4 rejects the whole bundle.
 */
const LEARNING_ROUTE = new RegExp(`^/accounts/[^/]+/${SECTION}(?:/([^/]+))?/?$`);

/**
 * Which Learning screen a path opens, as features/learning/router.tsx declares them: the
 * section root is the home, the two fixed pages win over `:stageId`, which takes the rest.
 */
export function learningSkeletonKind(pathname: string): LearningSkeletonKind | null {
  const match = LEARNING_ROUTE.exec(pathname);
  if (!match) return null;
  return learningSkeletonKindOfKey(match[1] ?? 'home');
}

/** The segment after `learning/`, as LearningLayout's menu keys it ('home' at the root). */
export function learningSkeletonKindOfKey(key: string): LearningSkeletonKind {
  if (key === 'home') return 'home';
  if (key === NEWS) return 'news';
  if (key === MCP) return 'mcp';
  return 'stage';
}
